import React from "react";
import { useNavigate } from "react-router-dom";

const BrokerPageHeader = ({ title, subtitle, step, backTo, action }) => {
  const navigate = useNavigate();

  return (
    <header className="broker-page-header">
      <div className="broker-page-header__title">
        {backTo && (
          <button
            className="broker-icon-button"
            type="button"
            onClick={() => navigate(backTo)}
            aria-label="Go back"
          >
            <i className="fa fa-arrow-left" aria-hidden="true"></i>
          </button>
        )}
        <div>
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>
      {step && <span className="broker-step">{step}</span>}
      {action}
    </header>
  );
};

export default BrokerPageHeader;
